import { showError } from "./ErrorPopup";
import React, { useState, useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { useNavigate } from "react-router-dom";
// import Lightbox from "yet-another-react-lightbox";
// import "yet-another-react-lightbox/styles.css";
import { initLightboxJS } from "lightbox.js-react";
import { SlideshowLightbox } from "lightbox.js-react";
import { apiFetch } from "../utils/apiClient";
import { Download } from "lucide-react";

function DemandeSchema({
  formData,
  currentPage,
  setCurrentPage,
  fetchData,
  user,
  authLoading,
  startDate,
  endDate,
  numeroFormulaire,
  periodeReclamation,
  selectedFormFilter,
}) {
  const [selectedForm, setSelectedForm] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [isdeleted, setIsdeleted] = useState(false);
  const navigate = useNavigate(); // Initialize navigate hook
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [open, setOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPassword, setShowPassword] = useState(false);


  useEffect(() => {
    initLightboxJS("Insert_Your_License_Key_Or_Use_Default", "default");
  }, []);

  const handleContinueClick = async () => {
    if (!selectedForm) return;

    const { formulaire, etatDemande } = selectedForm;
    const canEdit =
      etatDemande === "Brouillon" ||
      etatDemande === "Rejeté" ||
      etatDemande === "Soumis";

    switch (formulaire) {
      case "Changement adresse":
        if (canEdit)
          navigate("/FormulaireAdresse", { state: { selectedForm } });
        break;

      case "Changement de nom":
        if (canEdit) navigate("/FormulaireNom", { state: { selectedForm } });
        break;

      case "Accès au compte informatique":
        if (canEdit)
          navigate("/FormulaireReseauInfo", { state: { selectedForm } });
        break;

      case "Changement information bancaire":
        if (canEdit)
          navigate("/FormulaireInfoBancaires", { state: { selectedForm } });
        break;


      case "Accès hors pays":
        navigate("/Acceshorspays", { state: { selectedForm } });
        break;

      case "Antécédents criminels":
        if (canEdit)
          navigate("/antecedentsCriminels", { state: { selectedForm } });
        break;

      case "Demande de projet":
        if (canEdit) navigate("/demandeProjet", { state: { selectedForm } });
        break;

      

      case "Entente de travail en mode hybrid":
      case "Réclamation mensuelle de dépenses":
      case "Achat équipement informatique": {
        setIsLoading(true);

        const formPath = {
          "Entente de travail en mode hybrid": "/EntenteTravailHybrid",
          "Réclamation mensuelle de dépenses": "/formulaire",
          "Achat équipement informatique": "/achatEquipInfo",
        }[formulaire];
        const url = `${formPath}?numeroFormulaire=${selectedForm.numeroFormulaire}&page=Mes%20demandes`;

        window.open(url, "_blank");

        setIsLoading(false);
        break;
      }

      case "Demande AEFO":
        setIsLoading(true);
        sessionStorage.setItem(
          "numeroFormulaire",
          selectedForm.numeroFormulaire,
        );
        sessionStorage.setItem("userId", selectedForm.userId);
        sessionStorage.setItem("page", "Mes demandes");

        window.open("/formAefo", "_blank");
        setIsLoading(false);
        break;

      case "Demande FEESO":
        setIsLoading(true); // Start loading animation

        sessionStorage.setItem(
          "numeroFormulaire",
          selectedForm.numeroFormulaire,
        );
        sessionStorage.setItem("userId", selectedForm.userId);
        sessionStorage.setItem("page", "Mes demandes");

        window.open("/formFeeso", "_blank");
        setIsLoading(false);

        break;

      case "Demande SCFP":
        setIsLoading(true); // Start loading animation

        sessionStorage.setItem(
          "numeroFormulaire",
          selectedForm.numeroFormulaire,
        );
        sessionStorage.setItem("userId", selectedForm.userId);
        sessionStorage.setItem("page", "Mes demandes");

        window.open("/formScfp", "_blank");
        setIsLoading(false);

        break;
        
      default:
        console.warn("Formulaire non reconnu:", formulaire);
    }
  };

  // Pagination state
  // const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Calculate the number of pages
  const totalPages = Math.ceil(formData.length / itemsPerPage);

  // Get the current page's data
  const currentData = formData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const firstVisibleItem = (currentPage - 1) * itemsPerPage + 1;
  const lastVisibleItem = Math.min(currentPage * itemsPerPage, formData.length);

  const resultScopeMessage = periodeReclamation
    ? "Résultats pour le mois des dépenses sélectionné."
    : numeroFormulaire
      ? "Résultats correspondant au numéro recherché."
      : startDate || endDate
        ? "Résultats selon la période de soumission sélectionnée."
        : selectedFormFilter === "Antécédents criminels"
          ? "Demandes d’antécédents criminels des 12 derniers mois."
          : selectedFormFilter
            ? "Demandes des 4 derniers mois."
            : "Affichage des demandes récentes. Utilisez les filtres pour consulter l’historique.";

  const getVisiblePages = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const pages = [1];
    const rangeStart = Math.max(2, currentPage - 1);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 1);

    if (rangeStart > 2) pages.push("start-ellipsis");
    for (let page = rangeStart; page <= rangeEnd; page += 1) {
      pages.push(page);
    }
    if (rangeEnd < totalPages - 1) pages.push("end-ellipsis");
    pages.push(totalPages);

    return pages;
  };

  const getStatusDotColor = (etat) => {
    switch (etat) {
      case "En attente":
        return "bg-orange-500";
      case "Soumis":
        return "bg-blue-500";
      case "En traitement":
        return "bg-yellow-500";
      case "Rejeté":
        return "bg-red-500";
      case "Approuvé":
        return "bg-green-500";
      case "Supprimé":
        return "bg-red-700";
      default:
        return "bg-gray-500";
    }
  };

  const handleRowClick = (form) => {
    setSelectedForm(form);
  };

  const handleClosePopup = () => {
    setSelectedForm(null);
  };

  const handleDeleteClick = () => {
    setShowDeleteConfirmation(true);
  };

  const confirmDelete = async () => {
    try {
      // const response = await fetch(
      //   `${process.env.REACT_APP_API_BASE_URL}/formdelete/${selectedForm._id}?formulaire=${selectedForm.formulaire}`,
      //   {
      //     method: "DELETE",
      //   }
      // );
      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/modify-etatdemande/${selectedForm._id}`,
        {
          method: "PUT", // or 'POST' depending on your backend setup
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            etatDemande: "Supprimé",
            nomFormulaire: selectedForm.formulaire,
            userId: user.id,
            nom: user.displayName,
            email: user.mail,
            commentaire: "",
          }), // Update this value as needed
        },
      );
      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || result.message);
      }
        // fetchFormData();
        handleClosePopup();
        setShowDeleteConfirmation(false);
        setIsdeleted(true);
        setTimeout(() => {
          setIsdeleted(false);
          fetchData();
        }, 3000);
      
    } catch (error) {
      console.error(error);
      showError(error); // ou setError(error.message)
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };


  useEffect(() => {
  let url;
  if (
    selectedForm?.uploadedFile?.contentType === "application/pdf" &&
    selectedForm?.uploadedFile?.data
  ) {
    const byteCharacters = atob(selectedForm.uploadedFile.data);
    const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
    const blob = new Blob([new Uint8Array(byteNumbers)], {
      type: "application/pdf",
    });
    url = URL.createObjectURL(blob);
    setPdfUrl(url);
  }
  return () => {
    if (url) URL.revokeObjectURL(url);
    };
  }, [selectedForm]);

  const renderFormDetails = (form) => {
    return (
      <div className="space-y-6">
        <div className="bg-gray-50 p-4 rounded-xl shadow-sm border border-gray-200 space-y-2">
          <p>
            <strong>Formulaire:</strong> {form.formulaire}
          </p>
          <p>
            <strong>Numéro de formulaire:</strong> {form.numeroFormulaire}
          </p>
          <p>
            <strong>Nom:</strong> {form.nom}
          </p>
          {form.courriel && (
            <p>
              <strong>Courriel: </strong> {form.courriel}
            </p>
          )}
          {form.poste && (
            <p>
              <strong>Poste: </strong> {form.poste}
            </p>
          )}
          <p>
            <strong>Date de Soumission:</strong>{" "}
            {new Date(form.dateSoumission).toLocaleString("fr-FR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })}
          </p>
          {/* {!(form.formulaire==="Demande AEFO" ||form.formulaire==="Demande FEESO" ||form.formulaire==="Demande SCFP" ) && ( */}
          <p>
            <strong>Statut de la Demande:</strong> {form.etatDemande}
          </p>
          {/* )} */}
          {form.typeDemande && (
            <p>
              <strong>Type de la demande : </strong>{" "}
              {form?.typeDemande
                ? form.typeDemande === "rapportPolice"
                  ? "Rapport de police"
                  : "Déclaration annuelle des antécédents criminels"
                : null}
            </p>
          )}
          {form.formulaire === "Antécédents criminels" && form.matricule && (
            <p>
              <strong>Matricule : </strong> {form.matricule}
            </p>
          )}
          {form.formulaire === "Antécédents criminels" &&
            form.posteOccupe && (
              <p>
                <strong>Poste occupé : </strong> {form.posteOccupe}
              </p>
            )}
          {form.formulaire === "Antécédents criminels" &&
            form.dateDeclaration && (
              <p>
                <strong>Date de la déclaration : </strong>{" "}
                {new Intl.DateTimeFormat("fr-FR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  timeZone: "UTC",
                }).format(new Date(form.dateDeclaration))}
              </p>
            )}
          {form.formulaire === "Antécédents criminels" && form.annee && (
            <p>
              <strong>Année : </strong> {form.annee}
            </p>
          )}
          {form.formulaire === "Antécédents criminels" &&
            form.courrielDirection && (
              <p>
                <strong>Courriel de la direction : </strong>{" "}
                {form.courrielDirection.toLowerCase()}
              </p>
            )}
          {form.formulaire === "Antécédents criminels" && form.coupable && (
            <p>
              <strong>Déclaration de culpabilité : </strong>{" "}
              {form.coupable === "oui" ? "Oui" : "Non"}
            </p>
          )}
          {form.typeDocument && (
            <p>
              <strong>Type de document : </strong>{" "}
              {form?.typeDocument
                ? form.typeDocument === "RecuDemande"
                  ? "Accusé de réception de la demande de certificat de police"
                  : "Certificat de police"
                : null}
            </p>
          )}
          {form.dateDocumentPolice && (
            <p>
              <strong>Date de document : </strong> {form.dateDocumentPolice}
            </p>
          )}
          {form.declarationExacteEtComplete && (
            <p>
              <strong>Declaration exacte et complete : </strong>{" "}
              {form.declarationExacteEtComplete}
            </p>
          )}
          {form.motdepasseFile && (
  <p className="flex items-center gap-2">
    <strong>Mot de passe PDF : </strong>

    <span className="font-mono">
      {showPassword ? form.motdepasseFile : "••••••••"}
    </span>

    <button
      type="button"
      onClick={() => setShowPassword(prev => !prev)}
      className="text-gray-500 hover:text-gray-700"
      aria-label={
        showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"
      }
    >
      {showPassword ? (
        // Eye-off icon
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9.27-3.11-11-7
            1.02-2.32 2.82-4.27 5.125-5.675M6.1 6.1A9.969 9.969 0 0112 5
            c5 0 9.27 3.11 11 7a10.97 10.97 0 01-4.145 5.355M15 12a3 3 0 01-3 3
            m0-6a3 3 0 013 3m6 6L4 4.5"
          />
        </svg>
      ) : (
        // Eye icon
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M2.458 12C3.732 7.943 7.523 5 12 5
            c4.478 0 8.268 2.943 9.542 7
            -1.274 4.057-5.064 7-9.542 7
            -4.477 0-8.268-2.943-9.542-7z"
          />
        </svg>
      )}
    </button>
  </p>
)}
          {/* {form.dateDeclaration && (
          <p>
            <strong>Date de declaration : </strong> {form.dateDeclaration}
          </p>
        )} */}
          {form.dispositions && form.dispositions.length > 0 && (
            <div className="mt-8 pt-5">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Dispositions :
              </h3>

              <table className="w-full border border-gray-300 rounded-lg overflow-hidden table-fixed">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="p-3 text-left font-medium w-1/4">
                      Infraction
                    </th>
                    <th className="p-3 text-left font-medium w-1/6">Date</th>
                    <th className="p-3 text-left font-medium w-1/4">
                      Tribunal
                    </th>
                    <th className="p-3 text-left font-medium w-1/3">
                      Commentaire
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {form.dispositions.map((d, i) => (
                    <tr key={i} className="bg-white hover:bg-gray-50">
                      <td className="border-t px-3 py-2 break-all whitespace-pre-wrap max-w-xs">
                        {d.infractions}
                      </td>
                      <td className="border-t px-3 py-2">{d.date}</td>
                      <td className="border-t px-3 py-2 break-all whitespace-pre-wrap max-w-xs">
                        {d.tribunal}
                      </td>
                      <td className="border-t px-3 py-2 break-all whitespace-pre-wrap max-w-sm">
                        {d.commentaire}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {form.nomMembre && (
            <p>
              <strong>Nom du membre du personnel: </strong> {form.nomMembre}
            </p>
          )}
          {form.prenomMembre && (
            <p>
              <strong>Prénom du membre du personnel: </strong>{" "}
              {form.prenomMembre}
            </p>
          )}
          {form.posteMembre && (
            <p>
              <strong>Poste du membre du personnel: </strong> {form.posteMembre}
            </p>
          )}
          {form.lieuTravail && (
            <p>
              <strong>Lieu de travail: </strong> {form.lieuTravail}
            </p>
          )}

          {form.adressePostalResidentielle === "non" && (
            <p className="mt-3 block text-md font-medium text-blue-900">
              <strong>Adresse Résidentielle </strong>
            </p>
          )}

          {form.adresse && (
            <p>
              <strong>Adresse: </strong> {form.adresse}
            </p>
          )}

          {form.numeroappartement && (
            <p>
              <strong>Appartement: </strong> {form.numeroappartement}
            </p>
          )}

          {form.ville && (
            <p>
              <strong>Ville: </strong> {form.ville}
            </p>
          )}
          {form.province && (
            <p>
              <strong>Province: </strong> {form.province}
            </p>
          )}
          {form.codePostal && (
            <p>
              <strong>Code Postal: </strong> {form.codePostal}
            </p>
          )}

          {form.adressePostalResidentielle === "non" && (
            <p className="mt-3 block text-md font-medium text-blue-900">
              <strong>Adresse Postale </strong>
            </p>
          )}

          {form.adressePostalResidentielle === "non" && form.boitePostale && (
            <p>
              <strong>Boite Postale: </strong> {form.boitePostale}
            </p>
          )}

          {form.adressePostalResidentielle === "non" &&
            form.appartementPostale && (
              <p>
                <strong>Appartement / unité : </strong>{" "}
                {form.appartementPostale}
              </p>
            )}

          {form.adressePostalResidentielle === "non" && form.villePostale && (
            <p>
              <strong>Ville: </strong> {form.villePostale}
            </p>
          )}
          {form.adressePostalResidentielle === "non" &&
            form.provincePostale && (
              <p>
                <strong>Province: </strong> {form.provincePostale}
              </p>
            )}
          {form.adressePostalResidentielle === "non" &&
            form.codePostalPostale && (
              <p>
                <strong>Code Postal: </strong> {form.codePostalPostale}
              </p>
            )}

          {form.telephone && (
            <p className="mt-3">
              <strong>Numéro de téléphone principal: </strong>{" "}
              {`${form.telephone.slice(0, 3)} ${form.telephone.slice(
                3,
                6,
              )} ${form.telephone.slice(6, 10)}`}
            </p>
          )}

          {form.telephoneCellulaire && (
            <p>
              <strong>Autre numéro de téléphone (optionnel): </strong>{" "}
              {`${form.telephoneCellulaire.slice(
                0,
                3,
              )} ${form.telephoneCellulaire.slice(
                3,
                6,
              )} ${form.telephoneCellulaire.slice(6, 10)}`}
            </p>
          )}
          {form.dateEntreeEnVigueur && (
            <p>
              <strong>Date d'entrée en vigueur: </strong>{" "}
              {form.dateEntreeEnVigueur}
            </p>
          )}
          {form.dateDebut && (
            <p>
              <strong>Date de début: </strong> {form.dateDebut}
            </p>
          )}
          {form.dateFin && (
            <p>
              <strong>Date de fin: </strong> {form.dateFin}
            </p>
          )}
          {form.courrielSuperviseur && (
            <p>
              <strong>Courriel du superviseur: </strong>{" "}
              {form.courrielSuperviseur}
            </p>
          )}
          {form.nouveauNom && (
            <p>
              <strong>Nouveau Nom : </strong> {form.nouveauNom}
            </p>
          )}
          {form.nouveauPrenom && (
            <p>
              <strong>Nouveau Prénom : </strong> {form.nouveauPrenom}
            </p>
          )}
          {form.deuxiemePrenom && (
            <p>
              <strong>Deuxième Prénom : </strong> {form.deuxiemePrenom}
            </p>
          )}
          {form.institution && (
            <p>
              <strong>Institution : </strong> {form.institution}
            </p>
          )}
          {form.banque && (
            <p>
              <strong>Banque : </strong> {form.banque}
            </p>
          )}
          {form.numeroTransit && (
            <p>
              <strong>Numéro de transit : </strong> {form.numeroTransit}
            </p>
          )}
          {form.numeroCompte && (
            <p>
              <strong>Numéro de compte : </strong> {form.numeroCompte}
            </p>
          )}
          {form.periodReclamation && (
            <p>
              <strong>Période de la Réclamation :</strong>{" "}
              {new Intl.DateTimeFormat("fr-CA", {
                year: "numeric",
                month: "long",
                timeZone: "UTC", // <=== force UTC
              }).format(new Date(form.periodReclamation))}
            </p>
          )}
          {form.commentairesDemandeur && (
            <p>
              <strong>Commentaires du demandeur: </strong>{" "}
              {form.commentairesDemandeur}
            </p>
          )}
          {form.documentJustificatif && (
            <p>
              <strong>document justificatif : </strong>{" "}
              {form.documentJustificatif}
            </p>
          )}
          {/* 🔹 Bouton */}
      {form?.uploadedFile && (
        <div className="mt-4 w-3/4 flex items-center">
          <button
            onClick={() => setShowPopup(true)}
            className="mt-5 flex items-center gap-2 px-5 py-2.5 rounded-xl 
                       bg-gradient-to-r from-blue-600 to-blue-500 
                       text-white font-medium shadow-md 
                       hover:shadow-lg hover:scale-[1.03] 
                       active:scale-[0.97] 
                       transition-all duration-200"
          >
            
              <>
                📄 <span>Voir le document : {form?.uploadedFile.filename}</span>
              </>
          </button>
        </div>
      )}
        
        {showPopup && (
        <>
          {/* BACKDROP */}
          <div
            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
            onClick={closePopup}
          ></div>

          {/* MODAL */}
          <div
            className="fixed w-[65%] max-w-5xl h-[85%] 
                       top-1/2 left-1/2 
                       -translate-x-1/2 -translate-y-1/2 
                       bg-white rounded-2xl shadow-2xl z-50 
                       flex flex-col overflow-hidden"
          >
            {/* HEADER */}
            <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  Aperçu du fichier
                </h3>
                <p className="text-xs text-gray-500">
                  Visualisation rapide du document
                </p>
              </div>

              <button
                onClick={closePopup}
                className="text-gray-400 hover:text-gray-700 text-xl transition"
              >
                ✕
              </button>
            </div>

            {/* BODY */}
            <div className="flex-1 overflow-auto p-6 flex justify-center items-center bg-gray-50">

              {/* IMAGE */}
              { form?.uploadedFile?.contentType?.startsWith("image/") && (
                  <div className="space-y-4 text-center">
                    {/* DOWNLOAD */}
                    <div className="mt-10 flex items-center justify-center gap-3 text-sm text-white font-medium bg-green-700 px-4 py-2 rounded-full shadow-sm">
                      <span>Télécharger :</span>
                      <a
                        href={`data:${form?.uploadedFile.contentType};base64,${form?.uploadedFile.data}`}
                        download
                        className="p-2 rounded-full bg-white shadow hover:bg-gray-100 transition"
                      >
                        <Download className="w-4 h-4 text-gray-700" />
                      </a>
                    </div>

                    {/* IMAGE PREVIEW */}
                    <SlideshowLightbox>
                      <img
                        src={`data:${form?.uploadedFile.contentType};base64,${form?.uploadedFile.data}`}
                        alt="Aperçu"
                        className="max-h-[500px] rounded-xl shadow-md border cursor-zoom-in hover:scale-[1.02] transition"
                      />
                    </SlideshowLightbox>
                  </div>
                )}

              {/* PDF */}
              { form?.uploadedFile?.contentType === "application/pdf" &&
                pdfUrl && (
                  <iframe
                    src={pdfUrl}
                    title="PDF preview"
                    className="w-full h-[90%] border rounded-lg"
                  />
                )}
            </div>
          </div>
        </>
      )}
          {/* {form.uploadedFile && (
            <div className="mt-3 w-full flex items-center space-x-4">
              <p
                className="border rounded-lg px-4 py-2 w-[50%] bg-blue-900 text-white cursor-pointer inline-block hover:bg-blue-700 transition duration-200"
                onClick={() => setShowPopup(true)}
              >
                Voir le document : {form.uploadedFile.filename}
              </p>
            </div>
          )}
          {showPopup && form.uploadedFile?.data && (
            <>
              <div
                className="fixed inset-0 bg-black bg-opacity-50 z-40"
                onClick={closePopup}
              ></div>
              <div className="fixed w-[60%] h-[80%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 bg-white border shadow-lg rounded-lg z-50">
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800">
                      Aperçu du fichier
                    </h3>
                    {form.uploadedFile.contentType?.startsWith("image/") && (
                      <p className="text-sm text-gray-500">
                        Cliquez sur l’image pour l’agrandir
                      </p>
                    )}
                  </div>
                  <button
                    onClick={closePopup}
                    className="text-gray-500 hover:text-gray-700 font-bold text-xl"
                  >
                    X
                  </button>
                </div>

                
                {form.uploadedFile.contentType?.startsWith("image/") && (
                  //   <>
                  //   <img
                  //     src={`data:${form.uploadedFile.contentType};base64,${form.uploadedFile.data}`}
                  //     alt={form.uploadedFile.filename || "Uploaded File"}
                  //     onClick={() => setOpen(true)}
                  //     className="max-w-full max-h-[500px] rounded-lg mt-4 object-contain border cursor-pointer"
                  //   />
                  //   <Lightbox
                  //     open={open}
                  //     close={() => setOpen(false)}
                  //     slides={[
                  //       {
                  //         src: `data:${form.uploadedFile.contentType};base64,${form.uploadedFile.data}`,
                  //       },
                  //     ]}
                  //   />
                  // </>

                  <SlideshowLightbox className="mx-auto">
                    <img
                      src={`data:${form.uploadedFile.contentType};base64,${form.uploadedFile.data}`}
                      alt="Aperçu"
                      className="max-w-full max-h-[500px] rounded-lg border cursor-zoom-in"
                    />
                  </SlideshowLightbox>
                )}

                
                {form.uploadedFile.contentType === "application/pdf" && (
                  <iframe
                    src={`data:application/pdf;base64,${form.uploadedFile.data}`}
                    title="PDF preview"
                    className="w-[100%] h-[90%] border mt-4"
                  />
                )}
              </div>
            </>
          )} */}

          {form.traitant?.length > 0 &&
            !(
              form.formulaire === "Demande AEFO" ||
              form.formulaire === "Demande FEESO" ||
              form.formulaire === "Demande SCFP"
            ) && (
              <div className="mt-8">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  Traitants :
                </h3>
                <table className="w-full border border-gray-300 rounded-lg overflow-hidden ">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="p-3 text-left font-medium w-1/5">Nom</th>
                      <th className="p-3 text-left font-medium w-1/4">Email</th>
                      <th className="p-3 text-left font-medium w-1/6">État</th>
                      <th className="p-3 text-left font-medium w-1/6">
                        Date et heure
                      </th>
                      {(form.formulaire === "Achat équipement informatique" ||
                        form.formulaire === "Accès hors pays") && (
                        <th className="p-3 text-left font-medium w-1/6">
                          Notes
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      // form.traitant.map((t, index) => (
                      form.traitant
                        ?.filter((t, index, arr) => {
                          // On cache la ligne "Enregistrer"
                          if (
                            t.etatDemande === "Enregistrer" &&
                            arr[index + 1]?.etatDemande === "En traitement"
                          ) {
                            return false;
                          }

                          // On cache la ligne "En traitement" qui suit "Enregistrer"
                          if (
                            t.etatDemande === "En traitement" &&
                            arr[index - 1]?.etatDemande === "Enregistrer"
                          ) {
                            return false;
                          }

                          return true;
                        })
                        .map((t, index) => (
                          <tr key={index} className={` bg-white `}>
                            <td className="border-t px-3 py-2 break-words">
                              {t.nom}
                            </td>
                            <td className="border-t px-3 py-2 break-words">
                              {t.email}
                            </td>
                            <td className="border-t px-3 py-2">
                              {t.etatDemande}
                            </td>
                            <td className="border-t px-3 py-2">
                              {formatDate(t.dateHeure)}
                            </td>
                            {(form.formulaire ===
                              "Achat équipement informatique" ||
                              form.formulaire === "Accès hors pays") && (
                              <td className="border-t px-3 py-2 max-w-xs break-words whitespace-pre-wrap overflow-y-auto">
                                {t.commentaire}
                              </td>
                            )}
                          </tr>
                        ))
                    }
                  </tbody>
                </table>
              </div>
            )}

          {form.listeDesNotes?.length > 0 && (
            <div className="mt-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Commentaires :
              </h3>
              <table className="w-full border border-gray-300 rounded-lg overflow-hidden ">
                <thead className="bg-blue-700 text-white">
                  <tr>
                    <th className="p-3 text-left font-medium w-1/6">Nom</th>
                    <th className="p-3 text-left font-medium w-1/5">
                      Courriel
                    </th>
                    <th className="p-3 text-left font-medium w-1/2">
                      Commentaire
                    </th>
                    <th className="p-3 text-left font-medium w-1/5">
                      Date et heure
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {form.listeDesNotes.map((t, index) => (
                    <tr key={index} className={`bg-white`}>
                      <td className="border-t px-3 py-2 break-words">
                        {t.nom}
                      </td>
                      <td className="border-t px-3 py-2 break-words">
                        {t.courriel}
                      </td>
                      <td className="p-3 text-gray-700 whitespace-normal break-words break-all max-w-xs">
                        {t.commentaireUsers}
                      </td>
                      <td className="border-t px-3 py-2">{t.dateHeure}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* {form.commentaire && form.commentaireVisible === "oui" && (
          <p className="mt-4 text-lg text-gray-700">
            <strong className="text-blue-600">Note du traiteur :</strong> {form.commentaire}
          </p>
        )} */}
          {form.commentaire && form.commentaireVisible === "oui" && (
            <p className="mt-4 text-lg text-gray-700">
              <strong
                className={
                  form.etatDemande === "Approuvé"
                    ? "text-green-600"
                    : form.etatDemande === "Rejeté"
                      ? "text-red-600"
                      : "text-gray-600"
                }
              >
                Note du traiteur :
              </strong>{" "}
              {form.commentaire}
            </p>
          )}
        </div>
      </div>
    );
  };

  function formatDate(dateInput) {
    try {
      if (!dateInput) return "Date invalide";

      // Si c'est déjà un objet Date valide
      if (dateInput instanceof Date && !isNaN(dateInput)) {
        return dateInput.toLocaleString("fr-CA", {
          dateStyle: "short",
          timeStyle: "short",
        });
      }

      // Sinon, on tente avec le constructeur Date
      const parsed = new Date(dateInput);

      // Si le constructeur ne fonctionne pas, on essaie avec Date.parse()
      if (isNaN(parsed)) {
        const timestamp = Date.parse(dateInput);
        if (!isNaN(timestamp)) {
          return new Date(timestamp).toLocaleString("fr-CA", {
            dateStyle: "short",
            timeStyle: "short",
          });
        } else {
          return "Date invalide";
        }
      }

      return parsed.toLocaleString("fr-CA", {
        dateStyle: "short",
        timeStyle: "short",
      });
    } catch (e) {
      return "Date invalide";
    }
  }
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    content: "",
  });

  const handleMouseEnter = (e, content) => {
    const rect = e.target.getBoundingClientRect();
    const tooltipWidth = 280;
    const horizontalPosition = Math.min(
      rect.left,
      window.innerWidth - tooltipWidth - 16,
    );

    setTooltip({
      visible: true,
      x: Math.max(16, horizontalPosition),
      y: rect.bottom + 8,
      content,
    });
  };

  const handleMouseLeave = () => {
    setTooltip({ visible: false, x: 0, y: 0, content: "" });
  };

  const generateText = (etatDemande) => {
    switch (etatDemande) {
      case "En attente":
        return "La demande est en attente d'approbation par les gestionnaires de tâches.";
      case "En traitement":
        return "La demande est en cours de traitement par les gestionnaires de tâches.";
      case "Rejeté":
        return "La demande a été rejetée par les gestionnaires de tâches.";
      case "Approuvé":
        return "La demande a été approuvée par les gestionnaires de tâches.";
      case "Supprimé":
        return "La demande a été supprimée par l'utilisateur.";
      case "Soumis":
        return "La demande a été soumise par l'utilisateur.";
      default:
        return "La demande est encore à l'état de brouillon et n'est pas complète.";
    }
  };

  
  return (
    <div className="p-4">
      <div className=" w-full">

        <div className="mb-4 flex items-center gap-2 rounded-lg border border-blue-100 bg-blue-50/70 px-3 py-2 text-sm text-slate-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 flex-shrink-0 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
            />
          </svg>
          <span>{resultScopeMessage}</span>
        </div>
        <div className="overflow-x-auto rounded-xl shadow-lg border border-gray-200">
          <table className="min-w-full bg-white divide-y divide-gray-200">
            <thead className="sticky top-0 z-10 bg-blue-600 shadow-sm">
              <tr>
                {[
                  "Formulaire",
                  "Demandeur",
                  "Numéro du formulaire",
                  "Date de soumission",
                  "Statut",
                ].map((title) => (
                  <th
                    key={title}
                    className="px-5 py-3 text-left text-sm font-semibold text-white"
                  >
                    {title}
                  </th>
                ))}
                <th className="w-12 px-3 py-3">
                  <span className="sr-only">Consulter</span>
                </th>
              </tr>
            </thead>
{authLoading ? (
  <tbody className="bg-white divide-y divide-gray-200">
                  <tr>
                    <td colSpan="6" className="py-6 text-center">
                      <div className="flex items-center justify-center">
                        <div className="w-6 h-6 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                        <p className="ml-3 text-gray-700 font-medium">
                          Chargement en cours...
                        </p>
                      </div>
                    </td>
                  </tr></tbody>
                ) : (
            formData.length > 0 ? (
              <tbody className="bg-white text-[15px] divide-y divide-gray-200">

                {currentData.map((form, index) => (
                  <tr
                    key={index}
                    onClick={() => handleRowClick(form)}
                    className="group cursor-pointer transition-colors duration-150 hover:bg-blue-50"
                  >
                    <td className="px-5 py-3 text-gray-700">
                      {form.formulaire}
                      {form.periodReclamation && (
                        <>
                          {" "}
                          -{" "}
                          {new Intl.DateTimeFormat("fr-CA", {
                            year: "numeric",
                            month: "long",
                            timeZone: "UTC",
                          }).format(new Date(form.periodReclamation))}
                        </>
                      )}
                    </td>
                    <td className="px-5 py-3 text-gray-700">{form.nom}</td>
                    <td className="px-5 py-3 text-gray-700">
                      {form.numeroFormulaire}
                    </td>
                    <td className="px-5 py-3 text-gray-700">
                      {new Date(form.dateSoumission).toLocaleString("fr-FR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                    </td>
                    <td className="px-5 py-3">
                      {/* {!((form.formulaire==="Demande AEFO" ||form.formulaire==="Demande FEESO" ||form.formulaire==="Demande SCFP" ) 
              && form.etatDemande!=="Brouillon") && ( */}
                      <span
                        className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-sm font-medium text-slate-700"
                        onMouseEnter={(e) =>
                          handleMouseEnter(e, generateText(form.etatDemande))
                        }
                        onMouseLeave={handleMouseLeave}
                      >
                        <span
                          className={`h-2 w-2 flex-shrink-0 rounded-full ${getStatusDotColor(
                            form.etatDemande,
                          )}`}
                          aria-hidden="true"
                        />
                        {form.etatDemande}
                      </span>
                      {/* )} */}
                    </td>
                    <td className="w-12 px-3 py-3 text-right" aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-slate-400 transition-all duration-200 group-hover:translate-x-0.5 group-hover:text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                      </svg>
                    </td>
                  </tr>
                ))}

                
              </tbody>
            ) : (
              <p className="text-center mt-4 text-gray-500">
                Aucune demande trouvée.
              </p>
            )
          )}
          </table>
        </div>
      </div>

      {/* Pagination Controls */}
      {formData.length > 0 && (
        <div className="mt-5 flex flex-col items-center gap-3">
          <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-600">
            <span>
              Demandes {firstVisibleItem} à {lastVisibleItem} sur {formData.length}
            </span>
            <label className="inline-flex items-center gap-2">
              <span>Afficher</span>
              <select
                value={itemsPerPage}
                onChange={(event) => {
                  setItemsPerPage(Number(event.target.value));
                  setCurrentPage(1);
                }}
                className="rounded-lg border border-gray-200 bg-white px-2 py-1.5 text-sm text-gray-700 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100"
                aria-label="Nombre de demandes par page"
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
              </select>
              <span>par page</span>
            </label>
          </div>

          {totalPages > 1 && (
            <nav
              className="flex flex-wrap items-center justify-center gap-2"
              aria-label="Pagination des demandes"
            >
              <button
                onClick={() => {
                  window.scrollTo({ top: 280, behavior: "smooth" });
                  setCurrentPage((prev) => Math.max(prev - 1, 1));
                }}
                className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                disabled={currentPage === 1}
              >
                Précédent
              </button>

              {getVisiblePages().map((page) =>
                typeof page === "number" ? (
                  <button
                    key={page}
                    type="button"
                    onClick={() => {
                      setCurrentPage(page);
                      window.scrollTo({ top: 280, behavior: "smooth" });
                    }}
                    className={`h-10 min-w-10 rounded-lg px-3 text-sm font-semibold transition-colors ${
                      currentPage === page
                        ? "bg-blue-600 text-white shadow-sm"
                        : "border border-gray-200 bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-700"
                    }`}
                    aria-current={currentPage === page ? "page" : undefined}
                    aria-label={`Page ${page}`}
                  >
                    {page}
                  </button>
                ) : (
                  <span key={page} className="px-1 text-gray-400" aria-hidden="true">
                    …
                  </span>
                ),
              )}

              <button
                onClick={() => {
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages));
                  window.scrollTo({ top: 280, behavior: "smooth" });
                }}
                className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                disabled={currentPage === totalPages}
              >
                Suivant
              </button>
            </nav>
          )}
        </div>
      )}
      {tooltip.visible && (
        <div
          role="tooltip"
          className="pointer-events-none fixed z-[100] w-max max-w-[280px] rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm leading-5 text-slate-700 shadow-lg"
          style={{
            left: tooltip.x,
            top: tooltip.y,
          }}
        >
          {tooltip.content}
        </div>
      )}

      {/* Main Popup Modal */}
      {selectedForm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex justify-center items-start z-50 pt-10">
          <div className="bg-white p-8 rounded-2xl shadow-2xl w-[60%] max-w-[1200px] max-h-[90vh] overflow-y-auto relative">
            {/* Header */}
            <h2 className="text-2xl font-bold mb-4 text-gray-800 border-b pb-2">
              Détails de la Demande
            </h2>

            {/* Form Details */}
            <div className="max-h-[60vh] overflow-y-auto">
              {renderFormDetails(selectedForm)}
            </div>

            {/* Action Buttons */}
            {!showDeleteConfirmation && (
              <div className="mt-6 flex justify-between items-center">
                <div className="flex space-x-3">
                  {selectedForm.etatDemande === "Brouillon" && (
                    <>
                      {(selectedForm.traitant?.length === 0 ||
                        selectedForm.formulaire === "Réclamation mensuelle de dépenses" ||
                        selectedForm.formulaire === "Demande de projet"
                      ) && (
                        <button
                          className="px-4 py-2 rounded-lg bg-red-500 text-white font-semibold shadow-md hover:bg-red-600 transition-colors duration-200"
                          onClick={handleDeleteClick}
                        >
                          Supprimer
                        </button>
                      )}
                      <button
                        className="px-4 py-2 rounded-lg bg-green-600 text-white font-semibold shadow-md hover:bg-green-700 transition-colors duration-200"
                        onClick={handleContinueClick}
                      >
                        Continuer
                      </button>
                    </>
                  )}
                  {selectedForm.etatDemande === "Soumis" &&
                    selectedForm.typeDocument === "RecuDemande" && (
                      <>
                        <button
                          className="px-4 py-2 rounded-lg bg-green-600 text-white font-semibold shadow-md hover:bg-green-700 transition-colors duration-200"
                          onClick={handleContinueClick}
                        >
                          Continuer
                        </button>
                      </>
                    )}

                  {selectedForm.etatDemande === "Rejeté" &&
                    (
                      user.id === selectedForm.userId ||
                      user.id === selectedForm.soumisParAutreMembre?.userId
                    ) && (
                      <button
                        className="px-4 py-2 rounded-lg bg-green-600 text-white font-semibold shadow-md hover:bg-green-700 transition-colors duration-200"
                        onClick={handleContinueClick}
                      >
                        Resoumettre
                      </button>
                    )}

                  {(selectedForm.formulaire ==="Réclamation mensuelle de dépenses" ||
                    selectedForm.formulaire === "Demande AEFO" ||
                    selectedForm.formulaire === "Demande FEESO" ||
                    selectedForm.formulaire === "Demande SCFP" ||
                    selectedForm.formulaire ===
                      "Achat équipement informatique" ||
                    selectedForm.formulaire === "Accès hors pays" ||
                    selectedForm.formulaire === "Entente de travail en mode hybrid" ||
                    selectedForm.formulaire === "Demande de projet") &&
                    !["Brouillon", "Rejeté","Supprimé"].includes(
                      selectedForm.etatDemande,
                    ) && (
                      <button
                        className="px-4 py-2 rounded-lg bg-green-600 text-white font-semibold shadow-md hover:bg-green-700 transition-colors duration-200"
                        onClick={handleContinueClick}
                      >
                        Consulter
                      </button>
                    )}
                </div>

                <button
                  className="px-4 py-2 rounded-lg bg-gray-200 text-gray-800 font-semibold shadow-sm hover:bg-gray-300 transition-colors duration-200"
                  onClick={handleClosePopup}
                >
                  Fermer
                </button>
              </div>
            )}

            {/* Delete Confirmation */}
            {showDeleteConfirmation && (
              <div className="mt-6 p-4 bg-gray-50 rounded-xl border border-gray-200 shadow-inner">
                <h2 className="text-xl font-semibold mb-4 text-gray-800">
                  Confirmer la Suppression
                </h2>
                <div className="flex justify-end space-x-3">
                  <button
                    className="px-4 py-2 rounded-lg bg-red-500 text-white font-semibold shadow-md hover:bg-red-600 transition-colors duration-200"
                    onClick={confirmDelete}
                  >
                    Confirmer
                  </button>
                  <button
                    className="px-4 py-2 rounded-lg bg-gray-200 text-gray-800 font-semibold shadow-sm hover:bg-gray-300 transition-colors duration-200"
                    onClick={() => setShowDeleteConfirmation(false)}
                  >
                    Annuler
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Delete Confirmation Popup */}
      {/* {showDeleteConfirmation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-1/3">
            <h2 className="text-xl font-semibold mb-4">
              Confirmer la Suppression
            </h2>
            <p>Êtes-vous sûr de vouloir supprimer cette demande ?</p>
            <div className="mt-4 flex justify-end space-x-2">
              <button
                onClick={confirmDelete}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Confirmer
              </button>
              <button
                onClick={() => setShowDeleteConfirmation(false)}
                className="bg-gray-300 text-black px-4 py-2 rounded"
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )} */}

      {isdeleted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div className="flex items-center space-x-3 px-5 py-4 bg-white text-red-600 rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce">
            <CheckCircleIcon className="h-8 w-8 text-red-500 animate-pulse" />
            <span className="text-lg font-semibold">
              Le formulaire a été supprimé avec succès !
            </span>
          </div>
        </div>
      )}

      {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
          <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
          <p className="ml-3 text-gray-700 font-medium">
            Chargement en cours...
          </p>
        </div>
      )}
    </div>
  );
}

export default DemandeSchema;
